<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }}</span>
          </b-col>
          
          <!-- <b-col cols="12" sm="6" class="mt-2 mt-sm-0">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-button
                  @click="showfilter = !showfilter"
                  :pressed="!showfilter"
                  variant="outline-primary"
                  class="card-header-action mr-1"
                  squared
                  size="sm"
                  title="Show/Hide Filter"
                >
                  <i class="fa fa-filter"></i
                ></b-button>

                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="btable_find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!btable_find"
                        @click="btable_find = ''"
                      >
                        <i v-if="btable_find" class="fa fa-remove"></i>
                        <i v-if="!btable_find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col> -->
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct text-left">
          <b-card-body class="py-0">
            <!-- <b-row no-gutters v-if="showfilter">
              <b-col>
                <b-button
                  @click="showfilter = !showfilter"
                  variant="link"
                  class="card-header-action"
                  squared
                  size="sm"
                >
                  <i class="fa fa-filter pr-2"></i>Filter...</b-button
                >
              </b-col>
            </b-row> -->
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Email" label-size="sm" class="">
                  <b-input-group>
                    <b-form-input v-model="email" :debounce="options.debounce" placeholder="Email"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!email" @click="email = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Role" label-size="sm">
                  <treeselect instanceId="rolename" type="number" v-model="rolename" :clearable="true"
                    :options="roles_options" :multiple="true" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested></treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="First Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="firstname" :debounce="options.debounce"
                      placeholder="First Name"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!firstname" @click="firstname = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Last Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="lastname" :debounce="options.debounce"
                      placeholder="Last Name"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!lastname" @click="lastname = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent (Initials)" label-size="sm" class="">
                  <b-input-group>
                    <b-form-input v-model="initials" :debounce="options.debounce"
                      placeholder="Agent (Initials)"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!initials" @click="initials = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Department" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="department" :debounce="options.debounce"
                      placeholder="Department"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!department" @click="department = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <!--   <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Company" label-size="sm">
                    <b-input-group>
                      <b-form-input
                        v-model="company"
                        :debounce="options.debounce"
                        placeholder="Company"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!company"
                          @click="company = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Status" label-for="status" label-cols="12" label-size="sm">
                  <treeselect instanceId="status" type="number" v-model="status" :clearable="true"
                    :options="status_options" :multiple="false"></treeselect>
                  <!--     <b-input-group class="z-0">
                      <b-form-radio-group
                        v-model="status"
                        :options="[
                          { text: 'ENABLED', value: '0' },
                          { text: 'INVITED', value: '1' },
                          { text: 'SIGNUP', value: '2' },
                          { text: 'FORGOT', value: '3' },
                          { text: 'DISABLED', value: '9' },
                        ]"
                        buttons
                        button-variant="outline-success"
                        size="sm"
                        name="radio-btn-outline"
                        :debounce="options.debounce"
                        class="small-xs"
                      ></b-form-radio-group>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!status"
                          @click="status = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group> -->
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <b-row class="px-0 mt-0">
            <b-col cols="auto">
              <b-button-group class="z-0">
                <b-row align-h="start" no-gutters>
                  <b-col class="gridtoolbar" cols="auto" v-for="(tool, index) in tools.filter(
                    (o) => o.position == 'toolbar'
                  )" :key="index">
                    <b-button v-if="tool.type == 'button'" :id="'tool_' + tool.action" :size="tool.size"
                      :variant="tool.variant" :title="tool.title ? tool.title : toolLabel(tool)"
                      :squared="tool.squared ? 'squared' : null" :disabled="toolDisabled(tool.action)"
                      @click="toolClick(tool.action)">
                      <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                      <span v-if="toolLabel(tool)" v-html="toolLabel(tool)">
                      </span>
                      <i v-if="tool.icon2" :class="tool.icon2"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-button-group>
            </b-col>
            <b-col>
              <b-row align-h="end" no-gutters>
                <b-col cols="auto" v-for="(tool, index) in options.view" :key="index">
                  <span v-if="tool.type == 'label'" :class="tool.class">
                    {{ tool.label }}
                  </span>
                  <b-form-radio-group v-if="tool.type == 'radio-group'" :options="tool.options">
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="px-3">
          <b-overlay :show="options.overlay_show" rounded="sm" opacity="0.6" v-click-outside="outside">
            <div>
              <b-table :dark="$store.state.darkMode" ref="btable" :sticky-header="btable_height + 'px'" striped hover
                small caption-bottom show-empty selectable select-mode="multi" :busy="btable_busy" :items="btable_items"
                :filter="btable_find" :fields="options.fields" @row-selected="btable_rowSelected">
                <template #head(selected)>
                  <i id="selectall" class="ml-1" :class="btable_iconselected()" aria-hidden="true"
                    @click="btable_iconselectedClick()" title="Click to select/unselect all"></i>
                  <b-tooltip target="selectall" triggers="hover" placement="right">Click to select/unselect
                    all</b-tooltip>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner type="grow" variant="primary" class="align-middle mr-2"></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="btable_icon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div v-if="
                    options.badges &&
                    options.badges.find((obj) => obj.key == row.field.key)
                  ">
                    <span v-html="btable_rowBadgeCell(
                      row.item,
                      options.badges.find(
                        (obj) => obj.key == row.field.key
                      ),
                      options
                    )
                      "></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button variant="link" size="sm" title="Actions" :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')">
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover container="actions-container" triggers="click blur" placement="leftbottom"
                      :target="'popover-target-' + row.item.id">
                      <div>
                        <b-nav vertical>
                          <b-nav-item :title="action.label" v-for="action in btable_rowActionCell(
                            row.item,
                            options
                          )" :key="action.key" @click.stop="btable_rowClick(action.key, row)">
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i :class="btable_rowActionIcon(action, row.item)
                                  "></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button variant="link" size="sm" v-for="action in btable_rowActionCell(row.item, options)"
                      :key="action.key" @click.stop="btable_rowClick(action.key, row)" :title="action.label">
                      <i :class="btable_rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component :is="options.component.name" :selection="btable_selected" :config="cconfig"
                      @discard="toolClick('discard')" @refresh="toolClick('refresh')"></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button v-for="(button, index) in options.overlay.buttons" :key="index"
                      :style="button.style ? button.style : 'width: 80px'" :class="button.class
                        ? button.class
                        : button.dispatch
                          ? null
                          : 'ml-2'
                        " :variant="button.variant
                          ? button.variant
                          : button.dispatch
                            ? 'outline-primary'
                            : 'outline-secondary'
                          " :size="button.size ? button.size : 'sm'" :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? toolClick(button.dispatch)
                          : (options.overlay_show = false)
                        ">{{ button.label }}</b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
        </div>
      </div>
      <div v-if="component">
        <component :is="component" :selection="btable_selected" :config="cconfig" @saveit="saveit"
          @discard="toolClick('discard')" @refresh="toolClick('refresh')"></component>
      </div>


      <b-row v-if="password" class="px-3">
        <b-col>
          <b-alert show variant="danger">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                Password is: {{ password }} </b-col></b-row>
          </b-alert></b-col>
      </b-row>


      <b-row v-if="!component" class="excelsheetbuttons px-3" no-gutters>
        <b-col>
          <div v-if="btable_busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary">Updating ...</span>
          </div>
          <span v-if="!btable_busy" class="small text-primary ml-1">Found {{ rows }} rows</span>
        </b-col>
        <b-col class="text-right">
          <b-pagination hide-ellipsis v-model="currentpage" :total-rows="rows" :per-page="limit" align="right"
            size="sm"></b-pagination>
        </b-col>
        <b-col class="ml-2" cols="auto">
          <div class="pagelimit">
            <treeselect v-model="limit" :clearable="false" :options="options_pagesizes" size="sm" inline></treeselect>
          </div>
        </b-col>
      </b-row>
      <b-card-footer class="text-primary">
        <span v-html="message"></span>
      </b-card-footer>


    </b-card>

  </div>
</template>

<script>
import gql from "graphql-tag";
import UsersEdit from "./Components/UsersEdit";

export default {
  name: "users",
  components: { UsersEdit },
  watch: {
    async firstname() {
      await this.load();
    },
    async lastname() {
      await this.load();
    },
    async department() {
      await this.load();
    },
    async email() {
      await this.load();
    },
    async initials() {
      await this.load();
    },
    async status() {
      await this.load();
    },
    async rolename() {
      await this.load();
    },
  },
  data() {
    return {
      busy: false,
      firstname: null,
      lastname: null,
      initials: null,
      department: null,
      rolename: [],
      email: null,
      status: null,
      password: null,
      //role: null,
      roles_options: [],
      status_options: [
        {
          id: "0",
          label: "ENABLED",
        },
        {
          id: "1",
          label: "INVITED",
        },
        {
          id: "2",
          label: "SIGNUP",
        },
        {
          id: "3",
          label: "FORGOT",
        },
        {
          id: "9",
          label: "DISABLED",
        },
      ],
      options: {
        title: "Users",
        icon: "fa fa-user-circle pl-2",
        debounce: 500,
        tools: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-paper-plane text-primary",
            position: "toolbar",
            action: "invite",
            label: "Invite",
            component: {
              name: "",
            },
          },
          // {
          //   type: "button",
          //   size: "sm",
          //   variant: "outline-white",
          //   squared: "squared",
          //   icon: "fa fa-user-secret",
          //   position: "toolbar",
          //   action: "secret",
          //   label: "Secret",
          //   component: {
          //     name: "",
          //   },
          // },
        ],
        view: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-left",
          },
          {
            key: "email",
            label: "Email",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "rolename",
            label: "Role",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            // class: "text-center",
            class: "d-none d-sm-table-cell",
          },
          {
            key: "firstname",
            label: "First Name",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            class: "d-none d-sm-table-cell",
          },
          {
            key: "lastname",
            label: "Last Name",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            class: "d-none d-sm-table-cell",
          },

          {
            key: "department",
            label: "Department",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            class: "d-none d-sm-table-cell",
          },
          {
            key: "initials",
            label: "Agent",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            class: "text-center",
            // class: "d-none d-sm-table-cell",
          },
          {
            key: "company",
            label: "Company",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            class: "d-none d-sm-table-cell",
          },

          {
            key: "lastlogin",
            label: "Last Login",
            class: "d-none d-sm-table-cell",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(true)
                  .format("DD/MM/YYYY HH:mm:SS");
              }
              return result;
            },
          },
          {
            key: "status",
            label: "Status",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px w-sm-100pct",
          },
        ],
        badges: [
          {
            key: "status",
            type: "badge",
            Enabled: "success",
            Invited: "warning",
            Signup: "primary",
            Forgot: "secondary",
            Disabled: "danger",
            Created: "info",
            formatter: (value, key, item) => {
              switch (parseInt(value)) {
                case 0:
                  return "Enabled";
                  break;
                case 1:
                  return "Invited";
                  break;
                case 2:
                  return "Signup";
                  break;
                case 3:
                  return "Forgot";
                  break;
                case 4:
                  return "Created";
                  break;
                case 9:
                  return "Disabled";
                  break;
                default:
                  return value;
              }
            },
          },
          {
            key: "rolename",
            type: "badge",
            client: "warning",
            user: "primary",
            admin: "danger",
            api: "info",
            // formatter: (value, key, item) => {
            //   if (value) {
            //     return value.toLowerCase();
            //   } else {
            //     return "error";
            //   }
            // },
          },
        ],
        actions: [
          {
            key: "edit",
            label: "Edit",
            icon: "fa fa-pencil",
            single: true,
            multiple: false,
            component: {
              name: "UsersEdit",
            },
          },
          {
            key: "invite",
            label: "Invite",
            icon: "fa fa-paper-plane",
            single: true,
            multiple: false,
            overlay: {
              message: "Are you sure you want to invite user %email% ?",
              buttons: [
                {
                  label: "Yes",
                  variant: "primary",
                  dispatch: "invite",
                },
                {
                  label: "No",
                  class: "ml-2",
                },
              ],
            },
          },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  mounted() {
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.options.actions) {
      if (this.options.fields.some((e) => e.key === "actions")) {
      } else {
        this.options.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }
    if (this.user.permissions.includes("users.delete")) {
      this.options.actions.push({
        key: "deleteit",
        label: "Delete",
        icon: "fa fa-trash text-danger",
        single: true,
        multiple: true,
        overlay: {
          message: "Are you sure you want to delete %email% ?",
          buttons: [
            {
              label: "Yes",
              variant: "danger",
              dispatch: "deleteit",
            },
            {
              label: "No",
              class: "ml-2",
            },
          ],
        },
      });
    }

    this.resizableColumns();

    // Mix common tools with local tools
    this.tools = [...this.tools, ...this.options.tools];
    this.toolRemove("copy,import,archive");
    this.toolComponents([
      { action: "add", name: "UsersEdit" },
      { action: "edit", name: "UsersEdit" },
    ]);

    this.loadDDL();
    this.load();
  },

  methods: {
    async loadDDL() {
      console.log("loadDDL");
      // this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query usersroles {
              usersroles {
                id: name
                label: name
              }
            }
          `,
        });
        this.roles_options = response.data.usersroles;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async load(offset, limit) {
      if (!offset) {
        this.currentpage = 1;
        offset = 0;
      }

      this.btable_items = [];
      this.btable_busy = true;

      let variables = {
        offset,
        limit: limit ? limit : this.limit,
        firstname: this.firstname,
        lastname: this.lastname,
        department: this.department,
        initials: this.initials,
        email: this.email,
        status: this.status ? parseInt(this.status) : null,
        rolename: this.rolename.length > 0 ? this.rolename.join(",") : null,
        dateformat: this.dateformat,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query users_mssql(
              $limit: Int
              $offset: Int
              $email: String
              $firstname: String
              $lastname: String
              $department: String
              $initials: String
              $status: Int
              $rolename: String
              $dateformat: String
            ) {
              users_mssql(
                limit: $limit
                offset: $offset
                email: $email
                firstname: $firstname
                lastname: $lastname
                department: $department
                initials: $initials
                status: $status
                rolename: $rolename
                dateformat: $dateformat
              ) {
                icon: __typename
                id
                email
                # password
                firstname
                lastname
                initials
                department
                company
                rolename
                lastlogin
                status
                rows
              }
            }
          `,
          variables,
        });

        if (limit > this.limit) {
          return response.data.users_mssql;
        }

        this.btable_items = response.data.users_mssql;
        if (response.data.users_mssql.length > 0) {
          this.rows = response.data.users_mssql[0].rows;
        }
      } catch (error) {
        console.log(error);
      }

      this.btable_busy = false;
    },

    async _toolClick(a) {
      console.log("local toolClick: ", a);
      
      this.password = ""
      
      // this.cconfig.find((o) => o.key == "eventcode").value = this.eventcode;
      switch (a) {
        case "delete":
          await this.deleteit();
          break;
        case "invite":
          await this.invite();
          break;
        case "secret":
          await this.secret();
          break;

      }
      return;
    },
    _toolDisabled(a) {

      switch (a) {
        case "invite":
          return this.btable_selected.length > 0 ? false : true;
      }
    },

    async deleteit() {
      let rows = [];
      for (var i = 0; i < this.btable_selected.length; i++) {
        rows.push({ id: this.btable_selected[i].id });
      }
      let variables = { rows };
      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation users_delete_mssql($rows: [User_input]) {
              users_delete_mssql(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
        console.log(response);
      } catch (error) {
        console.log(error);
      }
      await this.load();
    },

    async invite() {
      let rows = [];
      for (var i = 0; i < this.btable_selected.length; i++) {
        rows.push({ id: this.btable_selected[i].id, status: 1 });
      }

      let variables = { rows };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation saveusers($rows: [User_input]) {
              saveusers(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.load();
    },

    async secret() {
      console.log('secret called')
      this.password = "xxx"
    }
  },
};
</script>

<style></style>